import i18n from "../i18n";
import { normalizeLocale } from "../i18n/config";

const getResolvedLocale = (localeOverride) => {
  const candidate = localeOverride || i18n.resolvedLanguage || i18n.language;
  return normalizeLocale(candidate);
};

export const getCurrentUiLocale = () => {
  return getResolvedLocale();
};

export const formatDateByLocale = (
  value,
  options = { year: "numeric", month: "short", day: "numeric" },
  localeOverride,
) => {
  if (!value) {
    return "";
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat(
    getResolvedLocale(localeOverride),
    options,
  ).format(date);
};

export const formatNumberByLocale = (value, options = {}, localeOverride) => {
  const parsedValue = Number(value);
  if (Number.isNaN(parsedValue)) {
    return "0";
  }

  return new Intl.NumberFormat(
    getResolvedLocale(localeOverride),
    options,
  ).format(parsedValue);
};

export const formatCurrencyByLocale = (
  value,
  currency = "USD",
  options = {},
  localeOverride,
) => {
  const parsedValue = Number(value);
  if (Number.isNaN(parsedValue)) {
    return new Intl.NumberFormat(getResolvedLocale(localeOverride), {
      style: "currency",
      currency,
      ...options,
    }).format(0);
  }

  return new Intl.NumberFormat(getResolvedLocale(localeOverride), {
    style: "currency",
    currency,
    ...options,
  }).format(parsedValue);
};

export default {
  getCurrentUiLocale,
  formatDateByLocale,
  formatNumberByLocale,
  formatCurrencyByLocale,
};
